import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { Status } from '@df/core/status';
import { UiComponent } from '@df/ui/ui.component';
import { TradeService } from '../../../checkout/module/trade/trade.service';

@Component({
    selector: 'account-history-invoices-pagination',
    templateUrl: './account-history-invoices-pagination.html',
    styleUrls: ['./account-history-invoices-pagination.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountHistoryInvoicesPaginationComponent extends UiComponent implements OnInit {
    @Input({ required: true })
    totalCount!: number;

    @Input({ required: true })
    page!: number;

    @Input({ required: true })
    pageSize!: number;

    @Input({
        required: true
    })
    status!: Status;

    @Output()
    pageChange = new EventEmitter<number>();

    protected numberOfPages = 0;

    protected goToPage(page: number): void {
        this.page = page;
        this.pageChange.emit(page);
    }

    override ngOnChanges(changes: any): void {
        if (changes['totalCount']) {
            this.numberOfPages = Math.ceil(this.totalCount / this.pageSize);
        }
        super.ngOnChanges(changes);
    }
}
